"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _adv = require("@/api/ads/adv");
var _enums = require("../enums");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'AdCode',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    id: {
      type: [String, Number],
      default: ''
    },
    adType: {
      type: Number
    },
    platform: {
      type: Number
    },
    appList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      platformOptions: _enums.platformOptions,
      typeOptions: _enums.typeOptions,
      dialogVisible: false,
      form: JSON.parse(JSON.stringify(_enums.defaultFormCodeData)),
      formRules: _enums.formCodeRules
    };
  },
  computed: {
    formData: function formData() {
      return [];
    },
    columns: function columns() {
      return [{
        key: 'codeName',
        visible: true,
        label: "\u4EE3\u7801\u4F4D\u540D\u79F0",
        width: 100
      }, {
        key: 'applicationName',
        visible: true,
        label: "\u6240\u5C5E\u5E94\u7528",
        width: 80
      }, {
        key: 'codeInfo',
        visible: true,
        label: "\u4EE3\u7801\u4F4D",
        width: 230
      }, {
        key: 'outPlatform',
        visible: true,
        label: "\u5E7F\u544A\u5546",
        width: 160,
        formatter: 'tag',
        formatOptions: {
          list: _enums.outPlatformOptions
        }
      }, {
        key: 'status',
        visible: true,
        label: "\u72B6\u6001",
        width: 80
      }, {
        key: 'remark',
        visible: true,
        label: "\u5907\u6CE8",
        width: 160
      }];
    },
    appOptions: function appOptions() {
      var _this = this;
      return this.appList.map(function (item) {
        var disabled = false;
        if (_this.platform === 1) {
          disabled = ![1].includes(item.appType);
        } else if ([2, 3].includes(_this.platform)) {
          disabled = ![2, 3].includes(item.appType);
        }
        return _objectSpread(_objectSpread({}, item), {}, {
          disabled: disabled
        });
      });
    },
    outPlatformOptions: function outPlatformOptions() {
      var _this2 = this;
      var list = _toConsumableArray(_enums.outPlatformOptions);
      return _enums.outPlatformOptions.map(function (item) {
        var disabled = false;
        if (_this2.platform === 1) {
          disabled = ![1, 2, 3].includes(item.value);
        } else if ([2, 3].includes(_this2.platform)) {
          disabled = ![4].includes(item.value);
        }
        return _objectSpread(_objectSpread({}, item), {}, {
          disabled: disabled
        });
      });
    }
  },
  watch: {
    value: {
      handler: function handler(newV) {
        if (newV) {
          this.init();
        }
      }
    }
  },
  mounted: function mounted() {},
  methods: {
    init: function init() {
      var _this3 = this;
      this.$nextTick(function () {
        _this3.resetList();
      });
    },
    handleClose: function handleClose() {
      this.$emit('input', false);
      this.list = [];
    },
    refreshList: function refreshList() {
      this.$refs.searchPage && this.$refs.searchPage.refresh();
    },
    resetList: function resetList() {
      this.$refs.searchPage && this.$refs.searchPage.resetSearch();
    },
    getList: function getList(query, sortMap) {
      var params = _objectSpread(_objectSpread({}, query), {}, {
        adsSlotId: this.id
      });
      return (0, _adv.advCodeListApi)(params).then(function (res) {
        var list = (res.list || []).map(function (item) {
          item.winsFlag = item.redeemCode ? 1 : 0;
          return item;
        });
        return {
          list: list,
          total: res.total
        };
      });
    },
    handleDelete: function handleDelete(row) {
      var _this4 = this;
      this.$modal.confirm('是否确认删除？').then(function () {
        return (0, _adv.advCodeDeleteApi)(row.id);
      }).then(function () {
        _this4.refreshList();
        _this4.$modal.msgSuccess('删除成功');
      });
    },
    closeEdit: function closeEdit() {
      this.dialogVisible = false;
      this.refreshList();
    },
    initForm: function initForm(data) {
      for (var key in data) {
        if (this.form.hasOwnProperty(key)) {
          this.form[key] = data[key];
        }
      }
    },
    //添加广告
    handleAdd: function handleAdd() {
      this.initForm(_enums.defaultFormCodeData);
      this.form.adsSlotId = this.id;
      this.dialogVisible = true;
    },
    //编辑广告
    handleEdit: function handleEdit(row) {
      this.initForm(row);
      this.dialogVisible = true;
    },
    // 修改状态
    handleStatusChange: function handleStatusChange(row) {
      var _this5 = this;
      var params = {
        id: row.id,
        status: row.status
      };
      this.loading = true;
      (0, _adv.advCodeSetStatusApi)(params).then(function (res) {
        _this5.loading = false;
        _this5.$message.success('更新状态成功');
      }).catch(function () {
        _this5.loading = false;
        _this5.$message.error('更新状态失败');
        row.status = row.status ? 0 : 1;
      });
    },
    changeApp: function changeApp(value) {
      var target = this.appList.find(function (item) {
        return item.value === value;
      });
      this.form.miniAppName = (target === null || target === void 0 ? void 0 : target.appName) || '';
    },
    submit: function submit() {
      var _this6 = this;
      this.$refs.form.validate(function (valid, obj) {
        if (valid) {
          _this6.postData();
        } else {
          for (var key in obj) {
            var msg = obj[key][0].message;
            return _this6.$message.warning(msg);
          }
        }
      });
    },
    // 新增保存数据
    postData: function postData() {
      var _this7 = this;
      this.loading = true;
      var data = _objectSpread({}, this.form);
      var func = data.id ? _adv.advCodeUpdateApi : _adv.advCodeCreateApi;
      func(data).then(function (res) {
        _this7.$message.success('保存成功');
        setTimeout(function () {
          _this7.closeEdit();
        }, 500);
        _this7.loading = false;
      }).catch(function (res) {
        _this7.loading = false;
      });
    }
  }
};